import { baseApi } from '../axios';

export const startAssessment = async ({ forPractice, publishedItemId }: { forPractice?: boolean; publishedItemId: string }) => {
	const response = await baseApi.get(`/assessment/published-item/${publishedItemId}/enrol?forPractice=${forPractice}`);
	return response;
};

export const startAssessmentBlockItem = async ({ forPractice, blockItemId }: { forPractice?: boolean; blockItemId: string }) => {
	const response = await baseApi.get(`/assessment/block-item/${blockItemId}/enrol?forPractice=${forPractice}`);
	return response;
};

export const getUserAssessmentSubmission = async ({ publishedItemId }: { publishedItemId?: string }) => {
	const response = await baseApi.get(`/user-assessment/publish-item/${publishedItemId}`);
	return response;
};

export const getUserAssessmentSubmissionBlockItem = async ({ blockItemId }: { blockItemId?: string }) => {
	const response = await baseApi.get(`/user-assessment/block-item/${blockItemId}`);
	return response;
};

export const getAssessmentReport = async ({ blockItemId }: { blockItemId?: string }) => {
	const response = await baseApi.get(`/assessment/block-item/${blockItemId}/report`);
	return response;
};
